import Immutable from "immutable";
import PropTypes from "prop-types";

export const textContentPropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.shape({
    blocks: PropTypes.array,
    entityMap: PropTypes.object
  }),
  PropTypes.instanceOf(Immutable.Map)
]);

export const outcomePropType = {
  quality: PropTypes.number,
  choose: PropTypes.string,
  name: PropTypes.string.isRequired,
  narrativeDesc: textContentPropType,
  whatHappens: textContentPropType
};

export const questionPropType = {
  author: PropTypes.string,
  comparatorTest: PropTypes.string,
  comparatorTestPresent: PropTypes.bool,
  comparison: PropTypes.string,
  indexTest: PropTypes.string,
  healthProblemOrPopulation: PropTypes.string,
  intervention: PropTypes.string,
  outcomes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired
    })
  ),
  question: PropTypes.string.isRequired,
  targetCondition: PropTypes.string.isRequired
};
